module.exports = __webpack_public_path__ + "static/media/4.1f54f754.mp4";